export default {"src":"/_next/static/media/dolphin.c710913d.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};